import { Observable, Subject } from 'rxjs';
import { File } from '../models/file.model';
import {
  RRIBatchOption,
  RRIDownloadBatchOptionSettings,
} from './table/batch-options.interface';

export interface RRIFileService<T> {
  isLoading: Subject<any>;
  fileDownload(
    entities: any[],
    visibleBatchOptions: RRIBatchOption<RRIDownloadBatchOptionSettings<T, any>>,
    singleDownload?: boolean,
  ): void;
  downloadFile(file: File): any;
  loadFile(lbActiveFile: File): Observable<any>;
}
